/**
 * SectionHeader — coherent editorial header used across the landing page
 * sections ("Informazioni generali", "La struttura", "Come prenotare").
 *
 * Pattern:
 *   [ small pill eyebrow ]
 *   [   Big title       ]
 *   [   subtitle text   ]
 *
 * Colors are driven by two accents so each block can keep its own hue while
 * sharing the same visual rhythm.
 */

import { motion } from "framer-motion";

const SectionHeader = ({
  icon: Icon,
  eyebrow,
  title,
  subtitle,
  accent = "#18181B",
  pillBg = "rgba(24,24,27,0.06)",
  pillText = "#18181B",
  titleColor = "#0F172A",
  subtitleColor = "#52525B",
  testId,
}) => (
  <div className={`relative text-center mb-7 md:mb-10`} data-testid={testId}>
    <motion.div
      initial={{ opacity: 0, scale: 0.94 }}
      whileInView={{ opacity: 1, scale: 1 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5 }}
      className="inline-flex items-center gap-1.5 md:gap-2 px-3 md:px-3.5 py-1 md:py-1.5 rounded-full text-[11px] md:text-xs font-black uppercase tracking-[0.2em] mb-2.5 md:mb-4"
      style={{ background: pillBg, color: pillText }}
    >
      {Icon && <Icon className="w-3.5 h-3.5 md:w-4 md:h-4" strokeWidth={2.4} />}
      {eyebrow}
    </motion.div>
    <h2
      className="text-3xl md:text-5xl font-black tracking-tight leading-[1.05] px-2"
      style={{ color: titleColor, letterSpacing: "-0.02em" }}
    >
      {title}
    </h2>
    {subtitle && (
      <p
        className="text-[15px] md:text-lg mt-2.5 md:mt-3 max-w-md mx-auto px-4"
        style={{ color: subtitleColor }}
      >
        {subtitle}
      </p>
    )}
  </div>
);

export default SectionHeader;
